import classNames from 'classnames'
import { useState } from 'react'

import type { Image } from 'types'
import { parseImageSrc } from 'ui-component-library/utils/helpers'
import Modal from 'ui-component-library/components/00-Primitives/Modal'
import LoadableImage from '../LoadableImage'
import style from './style.scss'

type Props = {
  className?: string
  image: Image
  isModal?: boolean
  sizes?: string
  gradient?: boolean
  onLoaded?: () => void
}

function InlineImage({
  className,
  image,
  sizes,
  isModal,
  onLoaded,
  gradient = true,
}: Props) {
  const { alt = '', src: imageSrc } = image
  const { src, srcSet } = parseImageSrc(imageSrc)
  const [isModalOpen, setIsModalOpen] = useState(false)

  function handleClick() {
    setIsModalOpen((s) => !s)
  }

  return (
    <>
      <div
        className={classNames(
          style.wrapper,
          { [style.isModal]: isModal, [style.gradient]: gradient },
          className,
        )}
        onClick={isModal ? handleClick : undefined}
      >
        <LoadableImage
          sizes={sizes}
          alt={alt}
          src={src}
          srcSet={srcSet}
          onLoaded={onLoaded}
        />
      </div>
      {isModalOpen && (
        <Modal>
          <div className={style.modal} onClick={handleClick}>
            <i className={style.closeIcon} />
            <img
              alt={alt}
              sizes={sizes}
              src={src}
              srcSet={srcSet}
              onLoad={onLoaded}
            />
          </div>
        </Modal>
      )}
    </>
  )
}

export default InlineImage
